import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { SERVICES } from "./data";

export default function Services() {
  return (
    <section
      id="leistungen"
      data-testid="services-manifesto-section"
      className="relative mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-36"
    >
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-blue-400">
          (01) — Leistungen
        </p>
        <h2 className="mt-4 max-w-3xl font-display text-3xl font-extrabold leading-tight text-slate-50 sm:text-5xl">
          Vier Disziplinen.
          <br />
          <span className="text-outline">Ein Anspruch: Perfektion.</span>
        </h2>
      </Reveal>

      <div className="mt-20 space-y-24 sm:space-y-32">
        {SERVICES.map((s, i) => {
          const odd = i % 2 === 1;
          return (
            <Reveal key={s.number} delay={0.05}>
              <article
                data-testid={`service-chapter-${s.number}`}
                className="group grid items-center gap-10 lg:grid-cols-12"
              >
                <div className={`lg:col-span-2 ${odd ? "lg:order-3" : "lg:order-1"}`}>
                  <span className="font-display text-7xl font-extrabold text-outline-blue opacity-50 transition-opacity duration-500 group-hover:opacity-100 sm:text-8xl">
                    {s.number}
                  </span>
                </div>
                <div className={`lg:col-span-5 ${odd ? "lg:order-2" : "lg:order-2"}`}>
                  <span className="inline-block rounded-full border border-cyan-400/30 bg-cyan-400/5 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-cyan-300">
                    {s.badge}
                  </span>
                  <h3 className="mt-4 font-display text-2xl font-bold text-slate-50 sm:text-3xl">
                    {s.title}
                  </h3>
                  <p className="mt-1 text-sm font-medium uppercase tracking-wider text-slate-500">
                    {s.subtitle}
                  </p>
                  <p className="mt-4 max-w-md text-sm leading-relaxed text-slate-400 sm:text-base">
                    {s.details}
                  </p>
                  <a
                    href="#kontakt"
                    data-testid={`service-cta-${s.number}`}
                    className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-blue-400 transition-colors duration-300 hover:text-blue-300"
                  >
                    Reparatur anfragen
                    <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                  </a>
                </div>
                <div className={`lg:col-span-5 ${odd ? "lg:order-1" : "lg:order-3"}`}>
                  <div className="relative overflow-hidden rounded-xl border border-white/10">
                    <img
                      src={s.image}
                      alt={s.title}
                      loading="lazy"
                      className="aspect-[16/10] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-tr from-[#07080c]/50 to-transparent" />
                  </div>
                </div>
              </article>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}
